module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/ToastClose.4f0d0980.svg";